// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyChmA-jsuEkvcElfXyGYcdISkKAodHq0YE",
  authDomain: "festigram-9c346.firebaseapp.com",
  projectId: "festigram-9c346",
  storageBucket: "festigram-9c346.firebasestorage.app",
  messagingSenderId: "444551713190",
  appId: "1:444551713190:web:3ded212d2b14c9346cbf67",
  measurementId: "G-Q3DQ1FJHY9",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
const storage = getStorage(app);

export { app, auth, db, storage }; // 👈 export app too!
